import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocPermissionsRoute: InvariantJiraRoute = {
	name: 'eoc-permissions',
	path: '/jira/ops/teams/:teamId/settings',
	exact: true,
};
